import { Component } from '@angular/core';

@Component({
  selector: 'app-taj-industries',
  templateUrl: './taj-industries.component.html',
  styleUrls: ['./taj-industries.component.scss']
})
export class TajIndustriesComponent {

}
